import { createZodDto } from './zod';

import { z } from 'zod';

const UpdateOrganizationSchema = z.object({
  name: z.string(),
  currency: z.string(),
  areShortLinksPublic: z.boolean(),
  enforceRestrictedFolders: z.boolean().optional(),
  // Only override the client may touch: it flips the `mcp` gate for the
  // organization (see OrganizationService.updateOrganization).
  mcpEnabled: z.boolean().optional(),
  logo: z.string().nullable().optional(),
});

export class UpdateOrganizationDto extends createZodDto(
  UpdateOrganizationSchema,
) {}
